import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import horse from "./horse-new.png";
import "./WatchLive.css";
import CryptoIconWrapper from "../../../cryptoicons/CryptoIconWrapper";
/**
 * Main WatchLive component
 * - 1 minute race
 * - Each token can freeze if it reaches the finish line early
 * - Race ends if all tokens are frozen or time is up
 * - Winner popup shown with final order
 */
const WatchLive = () => {
  const [progress, setProgress] = useState({
    btc: 10,
    eth: 10,
    xrp: 10
  });

  useEffect(() => {
    setTimeout(() => {
      const timer = setInterval(() => {
        setProgress(prev => ({
          btc: Math.min(prev.btc + Math.random() * 0.5, 100),
          eth: Math.min(prev.eth + Math.random() * 0.5, 100),
          xrp: Math.min(prev.xrp + Math.random() * 0.5, 100)
        }));
      }, 50);
      return () => clearInterval(timer);
    }, 1000);
  }, []);

  const RaceBar = ({
    color,
    progress,
    symbol,
  }) => (
    <div className="relative h-6 mb-8 group">
      <div
        className="absolute inset-0 overflow-hidden"
        style={{ width: '100%' }}
      >
        <div
          className={`h-full transition-all rounded-r-full duration-300 ease-out ${color}`}
          style={{ width: `${progress}%` }}
        />
      </div>
      <div
        className="absolute -translate-y-1/2 -mt-2 -ml-1 -translate-x-full flex flex-col items-center"
        style={{ left: `${progress}%` }}
      >
        <div className="w-20 h-22 flex items-center justify-center">
          <img
            src={horse}
            alt="Rider"
            className="w-20 h-20 object-contain"
          />
        </div>
        <div className="flex items-center gap-1 pr-2">
          <CryptoIconWrapper name={symbol.toLowerCase()} size={20} />
          <span className="text-white font-medium">{symbol}</span>
        </div>
      </div>
    </div>
  );

  RaceBar.propTypes = {
    color: PropTypes.string.isRequired,
    progress: PropTypes.number.isRequired,
    symbol: PropTypes.string.isRequired,
    icon: PropTypes.elementType.isRequired,
  };

  return (
    <div className="my-20">
      <div className="text-xs font-bold text-right mr-3">Finish</div>
      <div className="flex items-center justify-center  bg-race-background py-2 px-6">
        <div className="w-full max-w-5xl relative animate-fadeIn">
          <div className="absolute right-0 top-0 bottom-0">
            <svg width="13" height="261" viewBox="0 0 13 261" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="6.19048" height="6.19048" fill="white" />
              <rect x="6.19043" width="6.19048" height="6.19048" fill="black" />
              <rect x="6.19043" y="6.19141" width="6.19048" height="6.19048" fill="white" />
              <rect y="6.19141" width="6.19048" height="6.19048" fill="black" />
              <rect y="12.3828" width="6.19048" height="6.19048" fill="white" />
              <rect x="6.19043" y="12.3828" width="6.19048" height="6.19048" fill="black" />
              <rect x="6.19043" y="18.5742" width="6.19048" height="6.19048" fill="white" />
              <rect y="18.5742" width="6.19048" height="6.19048" fill="black" />
              <rect y="24.7637" width="6.19048" height="6.19048" fill="white" />
              <rect x="6.19043" y="24.7637" width="6.19048" height="6.19048" fill="black" />
              <rect x="6.19043" y="30.9551" width="6.19048" height="6.19048" fill="white" />
              <rect y="30.9551" width="6.19048" height="6.19048" fill="black" />
              <rect y="37.1465" width="6.19048" height="6.19048" fill="white" />
              <rect x="6.19043" y="37.1465" width="6.19048" height="6.19048" fill="black" />
              <rect x="6.19043" y="43.3379" width="6.19048" height="6.19048" fill="white" />
              <rect y="43.3379" width="6.19048" height="6.19048" fill="black" />
              <rect y="49.5273" width="6.19048" height="6.19048" fill="white" />
              <rect x="6.19043" y="49.5273" width="6.19048" height="6.19048" fill="black" />
              <rect x="6.19043" y="55.7188" width="6.19048" height="6.19048" fill="white" />
              <rect y="55.7188" width="6.19048" height="6.19048" fill="black" />
              <rect y="61.9102" width="6.19048" height="6.19048" fill="white" />
              <rect x="6.19043" y="61.9102" width="6.19048" height="6.19048" fill="black" />
              <rect x="6.19043" y="68.1016" width="6.19048" height="6.19048" fill="white" />
              <rect y="68.1016" width="6.19048" height="6.19048" fill="black" />
              <rect y="74.291" width="6.19048" height="6.19048" fill="white" />
              <rect x="6.19043" y="74.291" width="6.19048" height="6.19048" fill="black" />
              <rect x="6.19043" y="80.4824" width="6.19048" height="6.19048" fill="white" />
              <rect y="80.4824" width="6.19048" height="6.19048" fill="black" />
              <rect y="86.6738" width="6.19048" height="6.19048" fill="white" />
              <rect x="6.19043" y="86.6738" width="6.19048" height="6.19048" fill="black" />
              <rect x="6.19043" y="92.8652" width="6.19048" height="6.19048" fill="white" />
              <rect y="92.8652" width="6.19048" height="6.19048" fill="black" />
              <rect y="99.0547" width="6.19048" height="6.19048" fill="white" />
              <rect x="6.19043" y="99.0547" width="6.19048" height="6.19048" fill="black" />
              <rect x="6.19043" y="105.246" width="6.19048" height="6.19048" fill="white" />
              <rect y="105.246" width="6.19048" height="6.19048" fill="black" />
              <rect y="111.438" width="6.19048" height="6.19048" fill="white" />
              <rect x="6.19043" y="111.438" width="6.19048" height="6.19048" fill="black" />
              <rect x="6.19043" y="117.629" width="6.19048" height="6.19048" fill="white" />
              <rect y="117.629" width="6.19048" height="6.19048" fill="black" />
              <rect y="123.818" width="6.19048" height="6.19048" fill="white" />
              <rect x="6.19043" y="123.818" width="6.19048" height="6.19048" fill="black" />
              <rect x="6.19043" y="130.01" width="6.19048" height="6.19048" fill="white" />
              <rect y="130.01" width="6.19048" height="6.19048" fill="black" />
              <rect y="136.201" width="6.19048" height="6.19048" fill="white" />
              <rect x="6.19043" y="136.201" width="6.19048" height="6.19048" fill="black" />
              <rect x="6.19043" y="142.393" width="6.19048" height="6.19048" fill="white" />
              <rect y="142.393" width="6.19048" height="6.19048" fill="black" />
              <rect y="148.582" width="6.19048" height="6.19048" fill="white" />
              <rect x="6.19043" y="148.582" width="6.19048" height="6.19048" fill="black" />
              <rect x="6.19043" y="154.773" width="6.19048" height="6.19048" fill="white" />
              <rect y="154.773" width="6.19048" height="6.19048" fill="black" />
              <rect y="160.965" width="6.19048" height="6.19048" fill="white" />
              <rect x="6.19043" y="160.965" width="6.19048" height="6.19048" fill="black" />
              <rect x="6.19043" y="167.156" width="6.19048" height="6.19048" fill="white" />
              <rect y="167.156" width="6.19048" height="6.19048" fill="black" />
              <rect y="173.346" width="6.19048" height="6.19048" fill="white" />
              <rect x="6.19043" y="173.346" width="6.19048" height="6.19048" fill="black" />
              <rect x="6.19043" y="179.537" width="6.19048" height="6.19048" fill="white" />
              <rect y="179.537" width="6.19048" height="6.19048" fill="black" />
              <rect y="185.729" width="6.19048" height="6.19048" fill="white" />
              <rect x="6.19043" y="185.729" width="6.19048" height="6.19048" fill="black" />
              <rect x="6.19043" y="191.92" width="6.19048" height="6.19048" fill="white" />
              <rect y="191.92" width="6.19048" height="6.19048" fill="black" />
              <rect y="198.109" width="6.19048" height="6.19048" fill="white" />
              <rect x="6.19043" y="198.109" width="6.19048" height="6.19048" fill="black" />
              <rect x="6.19043" y="204.301" width="6.19048" height="6.19048" fill="white" />
              <rect y="204.301" width="6.19048" height="6.19048" fill="black" />
              <rect y="210.492" width="6.19048" height="6.19048" fill="white" />
              <rect x="6.19043" y="210.492" width="6.19048" height="6.19048" fill="black" />
              <rect x="6.19043" y="216.684" width="6.19048" height="6.19048" fill="white" />
              <rect y="216.684" width="6.19048" height="6.19048" fill="black" />
              <rect y="222.873" width="6.19048" height="6.19048" fill="white" />
              <rect x="6.19043" y="222.873" width="6.19048" height="6.19048" fill="black" />
              <rect x="6.19043" y="229.064" width="6.19048" height="6.19048" fill="white" />
              <rect y="229.064" width="6.19048" height="6.19048" fill="black" />
              <rect y="235.256" width="6.19048" height="6.19048" fill="white" />
              <rect x="6.19043" y="235.256" width="6.19048" height="6.19048" fill="black" />
              <rect x="6.19043" y="241.447" width="6.19048" height="6.19048" fill="white" />
              <rect y="241.447" width="6.19048" height="6.19048" fill="black" />
              <rect y="247.637" width="6.19048" height="6.19048" fill="white" />
              <rect x="6.19043" y="247.637" width="6.19048" height="6.19048" fill="black" />
              <rect x="6.19043" y="253.828" width="6.19048" height="6.19048" fill="white" />
              <rect y="253.828" width="6.19048" height="6.19048" fill="black" />
            </svg>

          </div>
          <div className="space-y-24 animate-slideIn">
            <RaceBar
              color="bg-race-bar-btc"
              progress={progress.btc}
              symbol="BTC"
              icon={() => (
                <div className="w-6 h-6 rounded-full bg-white flex items-center justify-center">
                  <span className="text-black font-bold text-sm">X</span>
                </div>
              )}
            />
            <RaceBar
              color="bg-race-bar-xrp"
              progress={progress.xrp}
              symbol="XRP"
              icon={() => (
                <div className="w-6 h-6 rounded-full bg-white flex items-center justify-center">
                  <span className="text-black font-bold text-sm">X</span>
                </div>
              )}
            />
            <RaceBar
              color="bg-race-bar-eth"
              progress={progress.eth}
              symbol="ETH"
              icon={() => (
                <div className="w-6 h-6 rounded-full bg-white flex items-center justify-center">
                  <span className="text-black font-bold text-sm">X</span>
                </div>
              )}
            />
          </div>
        </div>
      </div>
    </div>
  );
};


WatchLive.propTypes = {
  title: PropTypes.string.isRequired,
  amount: PropTypes.number.isRequired,
  timeLeft: PropTypes.shape({
    hours: PropTypes.number,
    minutes: PropTypes.number,
    seconds: PropTypes.number,
  }).isRequired,
  poolData: PropTypes.arrayOf(
    PropTypes.shape({
      symbol: PropTypes.string.isRequired,
      odds: PropTypes.number.isRequired,
      poolSize: PropTypes.number.isRequired,
    })
  ).isRequired,
  onPlaceBet: PropTypes.func.isRequired,
};
export default WatchLive;
